var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("stepheader", { attrs: { step: _vm.step } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "body current",
          attrs: {
            id: "wizard2-p-0",
            role: "tabpanel",
            "aria-labelledby": "wizard2-h-0",
            "aria-hidden": "false",
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-6" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.dataevento,
                    expression: "dataevento",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "date", id: "dataevento" },
                domProps: { value: _vm.dataevento },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.dataevento = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.oraevento,
                    expression: "oraevento",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "time", id: "oraevento" },
                domProps: { value: _vm.oraevento },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.oraevento = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("buttons", {
            attrs: { buttons: _vm.step.buttons },
            on: { action: _vm.fireaction },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "form-label", attrs: { for: "dataevento" } },
      [
        _vm._v("\nIndica la data dell'evento: "),
        _c("span", { staticClass: "tx-danger" }, [_vm._v("*")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "form-label", attrs: { for: "oraevento" } },
      [
        _vm._v("Indica l'ora dell'evento: "),
        _c("span", { staticClass: "tx-danger" }, [_vm._v("*")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }